export default __webpack_public_path__ + "static/media/Susan_G_Komen-logo.63cf0a6e.svg";